import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { gallery, galleryItem } from "../app/schema";

export const PATCH_GALLERY = "PATCH_GALLERY";
export const PATCH_GALLERY_SUCCESS = "PATCH_GALLERY_SUCCESS";
export const PATCH_GALLERY_ERROR = "PATCH_GALLERY_ERROR";

export const DELETE_GALLERY = "DELETE_GALLERY";
export const DELETE_GALLERY_SUCCESS = "DELETE_GALLERY_SUCCESS";
export const DELETE_GALLERY_ERROR = "DELETE_GALLERY_ERROR";

export const GET_GALLERY_GALLERY_ITEMS = "GET_GALLERY_GALLERY_ITEMS";
export const GET_GALLERY_GALLERY_ITEMS_SUCCESS = "GET_GALLERY_GALLERY_ITEMS_SUCCESS";
export const GET_GALLERY_GALLERY_ITEMS_ERROR = "GET_GALLERY_GALLERY_ITEMS_ERROR";

export const POST_GALLERY_GALLERY_ITEMS = "POST_GALLERY_GALLERY_ITEMS";
export const POST_GALLERY_GALLERY_ITEMS_SUCCESS = "POST_GALLERY_GALLERY_ITEMS_SUCCESS";
export const POST_GALLERY_GALLERY_ITEMS_ERROR = "POST_GALLERY_GALLERY_ITEMS_ERROR";

export const SET_IS_REMOVE_GALLERY_MODAL_VISIBLE = "SET_IS_REMOVE_GALLERY_MODAL_VISIBLE";
export const SET_IS_ADD_GALLERY_GALLERY_ITEM_MODAL_VISIBLE = "SET_IS_ADD_GALLERY_GALLERY_ITEM_MODAL_VISIBLE";

// Validation
const validateForm = {
  createGalleryGalleryItem: (validate, fields, oneField) => validate(
    fields,
    oneField
  )// .prop('name', 'Nazwa').required()
  .getErrors().promise
};

// Requests

const patchGallery = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/galleries/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteGallery = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/galleries/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych galerii, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

const getGalleryGalleryItemsGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/galleries/${uid}/gallery-items`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const postGalleryGalleryItems = (fetch, apiHost, accessToken, data, uid) =>
  fetch(`${apiHost}/v1/galleries/${uid}/gallery-items`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

export function updateGallery(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_GALLERY],
    payload: {
      promise: patchGallery(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, gallery);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeGallery(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_GALLERY],
    payload: {
      promise: deleteGallery(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function getGalleryGalleryItems(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_GALLERY_GALLERY_ITEMS],
    payload: {
      promise: getGalleryGalleryItemsGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, arrayOf(galleryItem));
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    },
    meta: {
      uid
    }
  });
}

export function createGalleryGalleryItem(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_GALLERY_GALLERY_ITEMS],
    payload: {
      promise: validateForm
        ["createGalleryGalleryItem"](validate, data)
        .then(() =>
          postGalleryGalleryItems(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data,
            uid
          ))
        .then(data => {
          return normalize(data, galleryItem);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function setIsRemoveGalleryModalVisible(value) {
  return {
    type: SET_IS_REMOVE_GALLERY_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setIsAddGalleryGalleryItemModalOpen(value) {
  return {
    type: SET_IS_ADD_GALLERY_GALLERY_ITEM_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

// Standard functions
export function validateFormFieldGaleries(form, name, value) {
  const feature = "galleries";
  let fields = {};
  fields[name] = value;
  return ({ fetch, validate, config, users }) => ({
    type: [`${VALIDATE_FORM_FIELD}_${feature.toUpperCase()}`],
    payload: {
      promise: validateForm[form](validate, fields, true).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/galleries/actions.js